import { proctorTypeLabelMap } from '@exam-center/exam-event-management';
import { ExamCenterProctorRequestType } from '@exam-center/graphql';
import { Button, Divider, Flex, Form, FormSearchMultipleSelection } from '@shared/components';
import { zodResolver } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import { useProctorRequestListSearchParams } from '../../hooks';

import {
  type ProctorRequestListFilterFormInput,
  ProctorRequestListFilterFormSchema,
} from './proctor-request-list-filter-form-schema';

const PROCTOR_TYPE_OPTIONS = [
  { label: 'ผู้คุมสอบประเภทที่ 1', value: ExamCenterProctorRequestType.Proctor_1 },
  { label: 'ผู้คุมสอบประเภทที่ 2', value: ExamCenterProctorRequestType.Proctor_2 },
];

export default function ProctorRequestListFilterForm() {
  const [{ proctorType: initialProctorType }, { changeProctorType }] =
    useProctorRequestListSearchParams();

  const formContext = useForm<ProctorRequestListFilterFormInput>({
    defaultValues: {
      proctorType: initialProctorType.map((type) => ({
        label: proctorTypeLabelMap[type],
        value: type,
      })),
    },
    resolver: zodResolver(ProctorRequestListFilterFormSchema),
  });

  const proctorType = formContext.watch('proctorType');

  const handleSubmitFilter = (formValues: ProctorRequestListFilterFormInput) => {
    const { proctorType } = formValues;
    const mappedProctorType = proctorType.map<ExamCenterProctorRequestType>((type) => type.value);

    changeProctorType(mappedProctorType);
  };

  const handleResetFilter = () => {
    formContext.reset({ proctorType: [] });
    handleSubmitFilter({ proctorType: [] });
  };

  return (
    <FormProvider {...formContext}>
      <Form onSubmit={formContext.handleSubmit(handleSubmitFilter)}>
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            gap: theme.spacing(4),
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: theme.shape.rounded(2),
            p: theme.spacing(4),
          })}
        >
          <FormSearchMultipleSelection
            name='proctorType'
            options={PROCTOR_TYPE_OPTIONS}
            label='ประเภทผู้คุมสอบ'
            placeholder='แสดงทั้งหมด'
            sx={{ width: 259 }}
            slotProps={{
              input: {
                placeholder: proctorType.length === 0 ? 'แสดงทั้งหมด' : '',
              },
            }}
          />
          <Divider />
          <Flex sx={(theme) => ({ justifyContent: 'end', gap: theme.spacing(2) })}>
            <Button color='secondary' variant='outlined' type='reset' onClick={handleResetFilter}>
              Reset
            </Button>
            <Button type='submit'>Apply</Button>
          </Flex>
        </Flex>
      </Form>
    </FormProvider>
  );
}
